<ridango-modal #modal [size]="'800'" [visible]="termsVisible" [isItSmall]="false" (onCloseModal)="closeTerms()">
    <ridango-terms-modal-content [termsUrl]="termsUrl" (onAgree)="agreeTerms($event)"> </ridango-terms-modal-content>
</ridango-modal>

<rwidget-login-form
    [captchaToggleAllowed]="captchaToggleAllowed"
    [showRequiredText]="visible"
    [strongAuthOptionsEnabled]="strongAuthOptionsEnabled"
    (onLogin)="ridangoLogin($event)"
    (onForgot)="forgot()"
    (onLoginIdCard)="idCardLogin()"
    (onLoginMobileId)="mobileIdLogin($event)"
    (onLoginSmartId)="smartIdLogin($event)">
</rwidget-login-form>

<!--Create account-->
<a class="create-account link--no-line" *ngIf="createAccountArea" [routerLink]="'/register' | localize" role="link">
    <p class="create-account__title">
        {{ 'CREATE_ACCOUNT' | translate }}
    </p>
    <p class="create-account__description">
        {{ 'CREATE_ACCOUNT_DESCRIPTION' | translate }}
    </p>
    <span
        >{{ 'START_HERE' | translate }}
        <span class="icon icon-arrow-right-link"></span>
    </span>
</a>
